<template>
  <footer class="portal-footer portal-footer--home">
    <div class="portal-footer__inner portal-footer__inner--home">
      <p>版权所有 © 全国社会艺术水平等级考试</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PortalFooter',
  props: {
    isHome: {
      type: Boolean,
      default: false
    }
  }
}
</script>
